module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige6-5b95fbe09ef10539d5eca6d2557e6679.jpg";